<script setup>
import { computed } from 'vue';
import XlButton from '../../xl/XlButton.vue';
import { lastActive } from '../../../helpers/messageTime';

const props = defineProps({
  // { waiting, oldest_since } from the Overview payload — the Messages page's own count.
  messages: { type: Object, default: null },
});

const emit = defineEmits(['open']);

const count = computed(() => props.messages?.waiting ?? 0);

const since = computed(() => {
  const label = lastActive(props.messages?.oldest_since);
  if (label === 'Today') return 'The oldest arrived today.';
  if (label === 'Yesterday') return 'The oldest has been waiting since yesterday.';

  return label.endsWith('ago') ? `The oldest has been waiting ${label.replace(' ago', '')}.` : `The oldest has been waiting since ${label}.`;
});
</script>

<template>
  <div v-if="count > 0" class="overview-waiting" data-testid="overview-waiting">
    <span class="overview-waiting__ico" aria-hidden="true">
      <svg width="23" height="23" viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="14" rx="3" stroke="currentColor" stroke-width="1.8" /><path d="m4 7 8 6 8-6" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" /></svg>
    </span>
    <div class="overview-waiting__text">
      <b>{{ count }} {{ count === 1 ? 'reply is' : 'replies are' }} outstanding</b>
      <div>{{ since }}</div>
    </div>
    <XlButton data-testid="open-messages" @click="emit('open')">Open messages</XlButton>
  </div>
</template>

<style scoped>
.overview-waiting {
  box-sizing: border-box;
  display: flex;
  gap: 13px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 22px 24px;
  border: 1px solid #F2DCB9;
  border-radius: var(--xl-radius-lg, 24px);
  background: var(--xl-color-warning-container, #FDF2E2);
  box-shadow: var(--xl-shadow-1);
  font-family: 'General Sans', 'Inter', -apple-system, 'Segoe UI', sans-serif;
}

.overview-waiting__ico {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 13px;
  display: grid;
  place-items: center;
  background: var(--xl-color-warning-container, #FDF2E2);
  color: var(--xl-color-warning, #8A5200);
}

.overview-waiting__text { flex: 1; min-width: 200px; }

.overview-waiting__text b { font-size: 15px; font-weight: 600; color: #1C1720; }

.overview-waiting__text div { font-size: 13.5px; color: #514A57; }
</style>
